// Shared residency-country list — used by signup/account UI (AuthModal, EC_Travel_v2)
// and by the admin coupon importer (AdminPanel) so both sides agree on the same codes.
// Codes match what Klook's affiliate CSV uses in "Applicable to residents of".
export const RESIDENCY_COUNTRY_MAP = {
  HK:'hong kong', MO:'macau', TW:'taiwan', SG:'singapore', TH:'thailand',
  MY:'malaysia', KR:'korea', JP:'japan', CN:'china', VN:'vietnam',
  PH:'philippines', IN:'india', ID:'indonesia', AU:'australia', NZ:'new zealand',
  AE:'dubai', US:'united states', GB:'uk', FR:'france', DE:'germany',
  IT:'italy', CH:'switzerland', ES:'spain',
};

export const RESIDENCY_CODES = Object.keys(RESIDENCY_COUNTRY_MAP);

export const RESIDENCY_LABELS = {
  HK:{ 'zh-HK':'香港',   'zh-CN':'香港',   en:'Hong Kong',      ja:'香港',           ko:'홍콩'      },
  MO:{ 'zh-HK':'澳門',   'zh-CN':'澳门',   en:'Macau',          ja:'マカオ',         ko:'마카오'    },
  TW:{ 'zh-HK':'台灣',   'zh-CN':'台湾',   en:'Taiwan',         ja:'台湾',           ko:'대만'      },
  SG:{ 'zh-HK':'新加坡', 'zh-CN':'新加坡', en:'Singapore',      ja:'シンガポール',   ko:'싱가포르'  },
  TH:{ 'zh-HK':'泰國',   'zh-CN':'泰国',   en:'Thailand',       ja:'タイ',           ko:'태국'      },
  MY:{ 'zh-HK':'馬來西亞','zh-CN':'马来西亚',en:'Malaysia',      ja:'マレーシア',     ko:'말레이시아'},
  KR:{ 'zh-HK':'韓國',   'zh-CN':'韩国',   en:'South Korea',   ja:'韓国',           ko:'한국'      },
  JP:{ 'zh-HK':'日本',   'zh-CN':'日本',   en:'Japan',          ja:'日本',           ko:'일본'      },
  CN:{ 'zh-HK':'中國',   'zh-CN':'中国',   en:'China',          ja:'中国',           ko:'중국'      },
  VN:{ 'zh-HK':'越南',   'zh-CN':'越南',   en:'Vietnam',        ja:'ベトナム',       ko:'베트남'    },
  PH:{ 'zh-HK':'菲律賓', 'zh-CN':'菲律宾', en:'Philippines',   ja:'フィリピン',     ko:'필리핀'    },
  IN:{ 'zh-HK':'印度',   'zh-CN':'印度',   en:'India',          ja:'インド',         ko:'인도'      },
  ID:{ 'zh-HK':'印尼',   'zh-CN':'印尼',   en:'Indonesia',      ja:'インドネシア',   ko:'인도네시아'},
  AU:{ 'zh-HK':'澳洲',   'zh-CN':'澳洲',   en:'Australia',      ja:'オーストラリア', ko:'호주'      },
  NZ:{ 'zh-HK':'紐西蘭', 'zh-CN':'新西兰', en:'New Zealand',   ja:'ニュージーランド',ko:'뉴질랜드' },
  AE:{ 'zh-HK':'阿聯酋', 'zh-CN':'阿联酋', en:'UAE',            ja:'アラブ首長国連邦',ko:'아랍에미리트'},
  US:{ 'zh-HK':'美國',   'zh-CN':'美国',   en:'United States',  ja:'アメリカ',       ko:'미국'      },
  GB:{ 'zh-HK':'英國',   'zh-CN':'英国',   en:'United Kingdom', ja:'イギリス',       ko:'영국'      },
  FR:{ 'zh-HK':'法國',   'zh-CN':'法国',   en:'France',         ja:'フランス',       ko:'프랑스'    },
  DE:{ 'zh-HK':'德國',   'zh-CN':'德国',   en:'Germany',        ja:'ドイツ',         ko:'독일'      },
  IT:{ 'zh-HK':'意大利', 'zh-CN':'意大利', en:'Italy',          ja:'イタリア',       ko:'이탈리아'  },
  CH:{ 'zh-HK':'瑞士',   'zh-CN':'瑞士',   en:'Switzerland',    ja:'スイス',         ko:'스위스'    },
  ES:{ 'zh-HK':'西班牙', 'zh-CN':'西班牙', en:'Spain',          ja:'スペイン',       ko:'스페인'    },
};

export const residencyLabel = (code, lang = 'zh-HK') =>
  RESIDENCY_LABELS[code]?.[lang] || RESIDENCY_LABELS[code]?.['zh-HK'] || code || '';

// Residency restriction always wins over destination match — a code only valid for
// HK residents must not show just because the trip destination happens to match.
export function residencyAllowed(residentCountriesStr, userResidency) {
  if (!residentCountriesStr || !residentCountriesStr.trim()) return true;
  const allowed = residentCountriesStr.split(',').map(s => s.trim().toUpperCase()).filter(Boolean);
  if (!allowed.length) return true;
  return !!userResidency && allowed.includes(userResidency.toUpperCase());
}
